import { render, staticRenderFns } from "./TerrainEditor.vue?vue&type=template&id=47de247c"
import script from "./TerrainEditor.vue?vue&type=script&lang=js"
export * from "./TerrainEditor.vue?vue&type=script&lang=js"
import style0 from "./TerrainEditor.vue?vue&type=style&index=0&id=47de247c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports